import { render, staticRenderFns } from "./Esg.vue?vue&type=template&id=c2191050&scoped=true"
import script from "./Esg.vue?vue&type=script&lang=js"
export * from "./Esg.vue?vue&type=script&lang=js"
import style0 from "./Esg.vue?vue&type=style&index=0&id=c2191050&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2191050",
  null
  
)

export default component.exports